import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Icon from 'semantic-ui-react/dist/es/elements/Icon/Icon';
import {
  humanReadableState,
  useVideoState,
} from '@msi-alta/opvideo-state-machine';
import { useFeatureFlag } from 'utils/customHooks/useFeatureFlag';
import { getOpParams } from 'utils/getOpParams';

const styles = {
  liveText: {
    textShadow: '0px 0px 1px #000000',
  },
};

const LiveButton = memo(({ duration, currentTime }) => {
  const { orgId } = getOpParams();
  const { value: isVideoStateMachineEnabled } = useFeatureFlag(
    'IS_VIDEO_STATE_MACHINE_ENABLED',
    orgId,
  );

  const { videoState } = useVideoState() ?? {};
  const { value: currentVideoState } = videoState ?? {};

  const isDurationInfiniteOrLessThanTwo =
    duration === Number.POSITIVE_INFINITY || duration - currentTime < 2;

  return (
    <div className="live-button">
      <Icon
        className="live-button-icon"
        size="tiny"
        color={isDurationInfiniteOrLessThanTwo ? 'red' : 'grey'}
        name="circle"
      />
      <div style={styles.liveText}>
        {isVideoStateMachineEnabled
          ? humanReadableState(currentVideoState)
          : 'Live'}
      </div>
    </div>
  );
});

LiveButton.displayName = 'LiveButton';

LiveButton.propTypes = {
  currentTime: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
};

export default LiveButton;
